import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type { AuditLog, ApiResponse } from '@/types'

export const activityLogKeys = {
  all: ['activity_logs'] as const,
  lists: () => [...activityLogKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) => [...activityLogKeys.lists(), filters] as const,
}

export function useActivityLogs(
  page = 1,
  auditableType?: string,
  actionFilter?: string,
  userId?: number,
  dateFrom?: string,
  dateTo?: string
) {
  return useQuery({
    queryKey: activityLogKeys.list({ page, auditableType, actionFilter, userId, dateFrom, dateTo }),
    queryFn: async () => {
      const params: Record<string, unknown> = { page }
      if (auditableType) params.auditable_type = auditableType
      if (actionFilter) params.action_filter = actionFilter
      if (userId) params.user_id = userId
      if (dateFrom) params.date_from = dateFrom
      if (dateTo) params.date_to = dateTo
      const { data } = await api.get<ApiResponse<AuditLog[]>>('/api/activity_logs', { params })
      return data
    },
  })
}
